import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSetUserInquiryMutation } from "../../../store/user/contentsApiSlice";
interface DataType {type : string, name : string, companyName : string, email : string, phone : string, title : string, contents : string, agree : boolean}
export const ContactInquiry = () => {
    const {t} = useTranslation()
    const [setUserInquiryApi] = useSetUserInquiryMutation()
    const [data, setData] = useState<DataType>({type : '', name : '', companyName : '', email : '', phone : '', title : '', contents : '', agree : false})
    const handleChange = (e:any) => {
        const {name, type, value, checked} = e.target;
        if(type === 'radio'){
            setData((prev)=>({...prev, type : value}))
        } else if(type === 'checkbox'){
            setData((prev)=>({...prev, agree : checked}))
        } else {
            setData((prev)=>({...prev, [name] : value}))
        }
    }
    const handleSave = async() => {
        if(!data?.agree){alert("개인정보 수집 및 이용 동의를 체크해야 합니다."); return;}
        const formData : any = new FormData()
        formData.append('inquiry_type', data?.type)
        formData.append('inquiry_name', data?.name)
        formData.append('inquiry_company_name', data?.companyName)
        formData.append('inquiry_email', data?.email)
        formData.append('inquiry_phone', data?.phone)
        formData.append('inquiry_title', data?.title)
        formData.append('inquiry_contents', data?.contents)
        const result : any = await setUserInquiryApi(formData)
        if(result.data.result === true){
            alert("문의가 정상적으로 등록되었습니다."); window.location.reload();
            window.scrollTo({top:0,behavior:'auto'})
        }
    }
    return(
        <>
        <div className="contentBox">
            <h3>
                <span>{t("contact_1")}</span>
                {t("contact_2")} 😄
            </h3>
            <ul>
                <li>
                    <h4>{t("contact_3")}</h4>
                    <div>
                        <div>
                            <input type="radio" value={'견적문의'} onChange={handleChange} name="contact" id="quote_inquiry" checked={data?.type === '견적문의' ? true : false}/>
                            <label htmlFor="quote_inquiry">{t("contact_4")}</label>
                        </div>
                        <div>
                            <input type="radio" value={'엔진문의'} onChange={handleChange} name="contact" id="engine_inquiry" checked={data?.type === '엔진문의' ? true : false}/>
                            <label htmlFor="engine_inquiry">{t("contact_5")}</label>
                        </div>
                        <div>
                            <input type="radio" value={'서비스문의'} onChange={handleChange} name="contact" id="service_inquiry" checked={data?.type === '서비스문의' ? true : false}/>
                            <label htmlFor="service_inquiry">{t("contact_6")}</label>
                        </div>
                    </div>
                </li>
                <li>
                    <h4>{t("contact_7")}</h4>
                    <ul>
                        <li>    
                            <div className="inputBox">
                                <label htmlFor="user_name">{t("contact_8")} <span>*</span></label>
                                <input type="text" value={data?.name} onChange={handleChange} name="name" id="user_name" required/>
                            </div>
                        </li>
                        <li>    
                            <div className="inputBox">
                                <label htmlFor="user_company">{t("contact_9")} <span>*</span></label>
                                <input type="text" value={data?.companyName} onChange={handleChange} name="companyName" id="user_company" required/>
                            </div>
                        </li>
                        <li>    
                            <div className="inputBox">
                                <label htmlFor="user_mail">{t("contact_10")} <span>*</span></label>
                                <input type="text" value={data?.email} onChange={handleChange} name="email" id="user_mail" required/>
                            </div>
                        </li>
                        <li>    
                            <div className="inputBox">
                                <label htmlFor="user_phone">{t("contact_11")} <span>*</span></label>
                                <input type="text" value={data?.phone} onChange={handleChange} name="phone" id="user_phone" required/>
                            </div>
                        </li>
                    </ul>
                </li>
                <li>
                    <h4>{t("contact_12")}</h4>
                    <div className="inputBox">
                        <input type="text" value={data?.title} onChange={handleChange} name="title" id="" required/>
                        <span>{t("contact_13")} <span>*</span></span>
                    </div>
                    <ul>
                        <li>    
                            <div className="textareaBox">
                                <textarea name="contents" value={data?.contents} onChange={handleChange} id="" required></textarea>
                                <span>{t("contact_14")} <span>*</span></span>
                            </div>
                        </li>
                    </ul>
                </li>
                <li>
                    <h4>{t("contact_15")}</h4>
                    <div>
                        <div>
                            <input type="checkbox" name="agreement" onChange={handleChange} id="agree"/>
                            <label htmlFor="agree">{t("contact_16")} <span>({t("contact_17")})</span></label>
                        </div>
                        <button onClick={handleSave}></button>
                    </div>
                </li>
            </ul>
        </div>
        </>
    )
}